import "./index.css"
import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import { Provider } from "mobx-react"

import appStore from "./store/app"
import history from "./history"
import ReactGA from "react-ga"

//appStore.action.setLocation(history.location)
// set initial location after half a second (allows for transition)
setTimeout(() => appStore.action.setLocation(history.location), 1)

// Listen for changes to the current location.
const unlisten = history.listen((location, action) => {
  appStore.action.setLocation(location)
})

// Winow listener
// monitor window size
const setWindowSize = () => {
  const width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  const height =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight
  appStore.action.setSize(width, height)
}
setWindowSize()
window.addEventListener("resize", setWindowSize)

// GA
ReactGA.initialize("UA-000000-01")

const render = App => {
  ReactDOM.render(
    <Provider app={appStore}>
      <App />
    </Provider>,
    document.getElementById("root")
  )
}

if (module.hot) {
  module.hot.accept("./App", () => {
    const NextApp = require("./App").default
    render(NextApp)
  })
}

render(App)



// WEBPACK FOOTER //
// ./src/index.js